(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function syncBrowsePlacement(isDesktop) {
    var list = document.querySelector('[data-sp-browse-list]');
    var home = document.querySelector('[data-sp-browse-home]');
    var mount = document.querySelector('[data-sp-browse-mount]');
    if (!list) return;
    if (isDesktop) {
      if (home && list.parentElement !== home) home.appendChild(list);
    } else if (mount && list.parentElement !== mount) {
      mount.appendChild(list);
    }
  }

  function scrollCurrentBrowseItem(container) {
    var current = (container || document).querySelector('.sp-browse__item.is-current');
    if (!current || typeof current.scrollIntoView !== 'function') return;
    current.scrollIntoView({ block: 'nearest' });
  }

  function visibleFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE)).filter(function (element) {
      return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
    });
  }

  function initHeader(root) {
    if (!root || root.dataset.spHeaderReady === 'true') return;
    root.dataset.spHeaderReady = 'true';

    if (root.classList.contains('sacpig-header--sticky')) {
      document.body.classList.add('sp-header-is-sticky');
      var headerHost = root.closest('header.header');
      if (headerHost) headerHost.classList.add('sp-header-is-sticky');
    }

    var desktopMedia = window.matchMedia('(min-width: 1024px)');
    var menuButton = root.querySelector('[data-sp-menu-button]');
    var drawer = root.querySelector('[data-sp-drawer]');
    var mobileShopButton = root.querySelector('[data-sp-mobile-shop]');
    var mobileShopPanel = root.querySelector('[data-sp-mobile-shop-panel]');
    var megaHost = root.querySelector('[data-sp-mega-host]');
    var megaButton = root.querySelector('[data-sp-mega-trigger]');
    var megaPanel = root.querySelector('[data-sp-mega-panel]');
    var searchButtons = Array.prototype.slice.call(root.querySelectorAll('[data-sp-search-button]'));
    var searchPanel = root.querySelector('[data-sp-search-panel]');
    var searchClose = root.querySelector('[data-sp-search-close]');
    var searchInput = searchPanel ? searchPanel.querySelector('input[type="search"]') : null;
    var scrim = root.querySelector('[data-sp-scrim]');
    var activeSearchButton = null;
    var megaCloseTimer = null;
    var animationDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 230;
    var shopAllToggle = root.querySelector('[data-sp-shop-all-toggle]');
    var shopAllPanel = root.querySelector('[data-sp-shop-all-panel]');

    function isOpen(element) {
      return Boolean(element && element.classList.contains('is-open'));
    }

    function reveal(element) {
      if (!element) return;
      window.clearTimeout(element.spHideTimer);
      element.hidden = false;
      element.offsetWidth;
      element.classList.add('is-open');
    }

    function conceal(element) {
      if (!element) return;
      element.classList.remove('is-open');
      window.clearTimeout(element.spHideTimer);
      element.spHideTimer = window.setTimeout(function () {
        if (!element.classList.contains('is-open')) element.hidden = true;
      }, animationDuration);
    }

    function updateHeaderHeight() {
      var headerHeight = root.offsetHeight + 'px';
      root.style.setProperty('--sp-header-height', headerHeight);
      document.documentElement.style.setProperty('--sp-header-height', headerHeight);
      document.body.style.setProperty('--sp-header-height', headerHeight);
    }

    function setShopAllExpanded(expanded) {
      if (!shopAllToggle || !shopAllPanel) return;
      shopAllToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      shopAllPanel.hidden = !expanded;
    }

    function handleShopAllToggle() {
      var expanded = shopAllToggle.getAttribute('aria-expanded') === 'true';
      setShopAllExpanded(!expanded);
    }

    function updateBackdrop() {
      if (isOpen(drawer) || isOpen(searchPanel) || isOpen(megaPanel)) {
        reveal(scrim);
      } else {
        conceal(scrim);
      }
    }

    function updateBodyLock() {
      document.body.classList.toggle('sp-nav-open', isOpen(drawer) || isOpen(searchPanel));
    }

    function closeMega(returnFocus) {
      window.clearTimeout(megaCloseTimer);
      if (!megaButton || !megaPanel) return;
      megaButton.setAttribute('aria-expanded', 'false');
      conceal(megaPanel);
      updateBackdrop();
      if (returnFocus) megaButton.focus();
    }

    var dropdownHosts = Array.prototype.slice.call(root.querySelectorAll('[data-sp-dropdown]'));

    function closeDropdown(host) {
      if (!host) return;
      var trigger = host.querySelector('[data-sp-dropdown-trigger]');
      var panel = host.querySelector('[data-sp-dropdown-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      conceal(panel);
    }

    function closeAllDropdowns() {
      dropdownHosts.forEach(closeDropdown);
    }

    function openDropdown(host) {
      if (!desktopMedia.matches || !host) return;
      closeMega(false);
      dropdownHosts.forEach(function (other) {
        if (other !== host) closeDropdown(other);
      });
      var trigger = host.querySelector('[data-sp-dropdown-trigger]');
      var panel = host.querySelector('[data-sp-dropdown-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      reveal(panel);
    }

    function openMega() {
      if (!desktopMedia.matches || !megaButton || !megaPanel) return;
      closeDrawer(false);
      closeSearch(false);
      closeAllDropdowns();
      window.clearTimeout(megaCloseTimer);
      megaButton.setAttribute('aria-expanded', 'true');
      reveal(megaPanel);
      updateBackdrop();
    }

    function scheduleMegaClose() {
      window.clearTimeout(megaCloseTimer);
      megaCloseTimer = window.setTimeout(function () {
        if (!megaHost || !megaHost.contains(document.activeElement)) closeMega(false);
      }, 160);
    }

    function closeDrawer(returnFocus) {
      if (!menuButton || !drawer) return;
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');
      conceal(drawer);
      updateBackdrop();
      updateBodyLock();
      if (returnFocus) menuButton.focus();
    }

    function openDrawer() {
      if (desktopMedia.matches || !menuButton || !drawer) return;
      closeSearch(false);
      closeMega(false);
      syncBrowsePlacement(false);
      menuButton.setAttribute('aria-expanded', 'true');
      menuButton.setAttribute('aria-label', 'Close menu');
      reveal(drawer);
      updateBackdrop();
      updateBodyLock();
      if (document.body.classList.contains('template-product')) {
        setShopAllExpanded(true);
        window.setTimeout(function () {
          scrollCurrentBrowseItem(drawer);
        }, 40);
      }
      window.setTimeout(function () {
        var first = mobileShopButton || visibleFocusable(drawer)[0];
        if (first) first.focus();
      }, 30);
    }

    function setSearchExpanded(expanded) {
      searchButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function closeSearch(returnFocus) {
      if (!searchPanel) return;
      setSearchExpanded(false);
      conceal(searchPanel);
      updateBackdrop();
      updateBodyLock();
      if (returnFocus && activeSearchButton && activeSearchButton.offsetParent !== null) activeSearchButton.focus();
      activeSearchButton = null;
    }

    function openSearch(trigger) {
      if (!searchPanel) return;
      closeDrawer(false);
      closeMega(false);
      closeAllDropdowns();
      activeSearchButton = trigger || searchButtons[0];
      setSearchExpanded(true);
      reveal(searchPanel);
      updateBackdrop();
      updateBodyLock();
      window.setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 30);
    }

    function toggleMobileShop() {
      if (!mobileShopButton || !mobileShopPanel) return;
      var expanded = mobileShopButton.getAttribute('aria-expanded') === 'true';
      mobileShopButton.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      mobileShopPanel.hidden = expanded;
      if (!expanded) {
        var firstCard = mobileShopPanel.querySelector('a');
        if (firstCard) window.setTimeout(function () { firstCard.focus(); }, 0);
      }
    }

    function trapFocus(event, elements) {
      if (event.key !== 'Tab' || !elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    if (menuButton) {
      menuButton.addEventListener('click', function () {
        if (isOpen(drawer)) closeDrawer(true);
        else openDrawer();
      });
    }

    if (mobileShopButton) mobileShopButton.addEventListener('click', toggleMobileShop);
    if (shopAllToggle) shopAllToggle.addEventListener('click', handleShopAllToggle);

    var mobileSubs = Array.prototype.slice.call(root.querySelectorAll('[data-sp-mobile-sub]'));

    mobileSubs.forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.parentElement ? button.parentElement.querySelector('[data-sp-mobile-sub-panel]') : null;
        var expanded = button.getAttribute('aria-expanded') === 'true';
        mobileSubs.forEach(function (other) {
          if (other === button) return;
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = other.parentElement ? other.parentElement.querySelector('[data-sp-mobile-sub-panel]') : null;
          if (otherPanel) otherPanel.hidden = true;
        });
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
      });
    });

    dropdownHosts.forEach(function (host) {
      var closeTimer = null;
      var trigger = host.querySelector('[data-sp-dropdown-trigger]');

      function scheduleDropdownClose() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          if (!host.contains(document.activeElement)) closeDropdown(host);
        }, 160);
      }

      host.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        openDropdown(host);
      });
      host.addEventListener('mouseleave', scheduleDropdownClose);
      host.addEventListener('focusin', function () {
        window.clearTimeout(closeTimer);
        openDropdown(host);
      });
      host.addEventListener('focusout', scheduleDropdownClose);

      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.addEventListener('click', function () {
          if (trigger.getAttribute('aria-expanded') === 'true') closeDropdown(host);
          else openDropdown(host);
        });
      }
    });

    if (megaButton) {
      megaButton.addEventListener('click', function (event) {
        if (event.detail > 0) {
          openMega();
        } else if (isOpen(megaPanel)) {
          closeMega(true);
        } else {
          openMega();
        }
      });
    }

    if (megaHost) {
      megaHost.addEventListener('mouseenter', openMega);
      megaHost.addEventListener('mouseleave', scheduleMegaClose);
      megaHost.addEventListener('focusout', scheduleMegaClose);
    }

    searchButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (isOpen(searchPanel)) closeSearch(true);
        else openSearch(button);
      });
    });

    if (searchClose) searchClose.addEventListener('click', function () { closeSearch(true); });

    if (scrim) {
      scrim.addEventListener('click', function () {
        if (isOpen(searchPanel)) closeSearch(true);
        else if (isOpen(drawer)) closeDrawer(true);
        else closeMega(false);
      });
    }

    if (drawer) {
      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a')) closeDrawer(false);
      });
    }

    document.addEventListener('pointerdown', function (event) {
      if (isOpen(megaPanel) && megaHost && !megaHost.contains(event.target)) closeMega(false);
      dropdownHosts.forEach(function (host) {
        if (!host.contains(event.target)) closeDropdown(host);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (isOpen(searchPanel)) {
          event.preventDefault();
          closeSearch(true);
        } else if (isOpen(drawer)) {
          event.preventDefault();
          closeDrawer(true);
        } else if (isOpen(megaPanel)) {
          event.preventDefault();
          closeMega(true);
        } else {
          var openDrop = dropdownHosts.filter(function (host) {
            var trigger = host.querySelector('[data-sp-dropdown-trigger]');
            return trigger && trigger.getAttribute('aria-expanded') === 'true';
          })[0];
          if (openDrop) {
            event.preventDefault();
            closeDropdown(openDrop);
            var dropTrigger = openDrop.querySelector('[data-sp-dropdown-trigger]');
            if (dropTrigger) dropTrigger.focus();
          }
        }
        return;
      }

      if (isOpen(searchPanel)) {
        trapFocus(event, visibleFocusable(searchPanel));
      } else if (isOpen(drawer)) {
        trapFocus(event, [menuButton].concat(visibleFocusable(drawer)).filter(Boolean));
      }
    });

    function handleBreakpointChange() {
      syncBrowsePlacement(desktopMedia.matches);
      if (desktopMedia.matches) {
        closeDrawer(false);
        setShopAllExpanded(false);
        window.setTimeout(function () {
          scrollCurrentBrowseItem(document.querySelector('[data-sp-browse-rail]'));
        }, 40);
      } else {
        closeMega(false);
        closeAllDropdowns();
      }
      updateHeaderHeight();
    }

    if (desktopMedia.addEventListener) desktopMedia.addEventListener('change', handleBreakpointChange);
    else desktopMedia.addListener(handleBreakpointChange);

    window.addEventListener('resize', updateHeaderHeight, { passive: true });
    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(updateHeaderHeight);
      resizeObserver.observe(root);
    }
    updateHeaderHeight();
    syncBrowsePlacement(desktopMedia.matches);
    if (desktopMedia.matches) scrollCurrentBrowseItem(document.querySelector('[data-sp-browse-rail]'));
  }

  function initAll(scope) {
    var container = scope || document;
    if (container.matches && container.matches('[data-sp-header]')) initHeader(container);
    Array.prototype.forEach.call(container.querySelectorAll('[data-sp-header]'), initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
